import React, { useState, useEffect } from 'react';
import Button from './Button';

const ChapterHeader = ({ name, logo, description, actions, currentSection, chapterSlug }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 640); // Tailwind-style "sm"
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
      <div
        style={{
          backgroundColor: '#100F1C',
          color: '#ffffff',
          padding: '3rem 1.5rem 1rem',
          textAlign: 'center',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        <div style={{ textAlign: 'left', marginBottom: '1rem' }}>
          <a href="/" className="link-text">
            ← Back to DoQuantum.org
          </a>
        </div>

        {logo && (
          <img
            src={logo}
            alt={`${name} logo`}
            style={{
              height: '80px',
              marginBottom: '1rem',
              objectFit: 'contain',
            }}
          />
        )}

        <h1 className="huge-title">{name}</h1>
        {description && <p className="subtitle">{description}</p>}
      </div>

      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 99,
          backgroundColor: '#0F0F1A',
          padding: '1rem 0',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '.5rem',
            padding: '0 1rem',
            maxWidth: '600px',
            margin: '0 auto',
          }}
        >
          {actions.map((action, idx) => {
            const isActive = currentSection === action.id;
            return (
              <div
                key={idx}
                style={{
                  flex: isMobile ? '0 0 calc(50% - 0.5rem)': '0 0 calc(25% - 0.5rem)' ,
                }}
              >
                <Button
                  label={action.label}
                  to={`/chapters/${chapterSlug}?section=${action.id}`}
                  base="transparent"
                  hover="#c026d3"
                  pressed="#a21caf"
                  style={{
                    color: isActive ? '#fff' : '#a5b4fc',
                    width: '100%',
                    padding: '0.5rem 0',
                    fontWeight: isActive ? 700 : 500,
                    border: '1px solid #c026d3',
                    backgroundColor: isActive ? '#c026d3' : 'transparent',
                    boxShadow: isActive ? '0 0 0 1px #f9a8d4' : 'none',
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ChapterHeader;
